import { BrandBusinessAreaType } from '../ts-config';
import { kaXTC } from '@/ka/xtc/config';

/* 定制化客户的所有特殊功能，在前端做成配置化 */
export function getSpecialConfig(tenantCheckData, typeDimension, extraConfig) {
  return {
    tenantCheckData,
    /* 顶部筛选栏配置 */
    topFilterConfig: getTopFilterConfig(tenantCheckData, typeDimension, extraConfig),

    /* 城市视角左侧栏小圈配置 */
    cityLeftContentConfig: getCityLeftContentConfig(tenantCheckData, extraConfig),

    /* 小圈（开店区域，基础版商圈，定制版Mall等）右侧详情卡片配置 */
    smallCircleRightCardConfig: getSmallCircleRightCardConfig(tenantCheckData),

    /* 其他配置 */
    // 是否显示小天才租户的内容
    contentType: getContentModule(tenantCheckData),
    // 是否将商圈类型中的商业体，改为MALL
    showAsMall: getShowAsMall(tenantCheckData),
    // 页面中的大圈字段自定义映射名=》默认：品牌商圈
    bigCircleCustomName: extraConfig.brandBusinessArea,
    // 页面中的商圈字段自定义映射名=》默认：商圈
    shopCircleCustomName: getShopCircleCustomName(tenantCheckData, extraConfig.openingAreaAlias),
    // 页面中的门店映射名=》默认：门店
    shopCustomName: getShopCustomName(tenantCheckData),
    // 页面中的分公司映射名=》默认：分公司
    branchCompanyName: extraConfig.branchCompanyAlias,
    // 初次切换至城市化后是否需要定位至目标小圈或者大圈，或者不定位
    needJumpToFirstConfig: getNeedJumpToFirstConfig(tenantCheckData),
    // 默认配置接口参数集合
    defaultConfig: extraConfig.defaultConfig,
    // 别名存储
    alias: {
      openingAreaAlias: extraConfig.openingAreaAlias,
      brandBusinessArea: extraConfig.brandBusinessArea
    },
    // 有权限的城市列表，管理员会返回全部城市
    cityPermission: extraConfig.userInfo.cities,
  };
}

// 是否显示小天才租户的内容
function getContentModule(tenantCheckData) {
  let content = ContentType.Default; // 默认SaaS版
  if (kaXTC(tenantCheckData)) {
    content = ContentType.XTC;
  }
  return content;
}

// 是否将商圈类型中的商业体，改为MALL
function getShowAsMall(tenantCheckData) {
  let res = false;
  if (kaXTC(tenantCheckData)) {
    res = true;
  }
  return res;
}

// 初次切换至城市化后是否需要定位至目标小圈或者大圈，或者不定位
function getNeedJumpToFirstConfig(tenantCheckData) {
  const config: any = {
    needJump: true, // 是否需要定位到当前城市的第一名小圈或者大圈
    jumpType: 'small', // small: 小圈（开店区域、Mall等）, big: 大圈(品牌商圈)。
    targetFirstData: null, // 当前城市的第一名数据(主要用到id)
  };
  if (kaXTC(tenantCheckData)) {
    // config.jumpType = 'big'; // 不跳到第一名
  }
  return config;
}

// 开店区域配置名字
function getShopCircleCustomName(tenantCheckData, openingAreaAlias) {
  let name = openingAreaAlias;
  if (kaXTC(tenantCheckData)) { // 小天才的商圈被定义为Mall（小圈）
    name = 'Mall';
  }
  return name;
}

// 门店配置名字
function getShopCustomName(tenantCheckData) {
  let name = '门店';
  if (kaXTC(tenantCheckData)) {
    name = '售点';
  }
  return name;
}

// 门店筛选配置
function getStoreFilters(tenantCheckData, extraConfig) {
  const res:any = {};
  // 处理门店状态参数的映射
  res.storeStatus = {
    visible: true,
    name: '门店状态',
  };
  if (kaXTC(tenantCheckData)) { // 小天才租户
    res.storeStatus.visible = true;
  }
  // 处理门店状态参数的映射
  res.storeType = {
    visible: true,
    name: extraConfig?.standardStoreTypeAlias || '门店类型',
  };
  if (kaXTC(tenantCheckData)) { // 小天才租户
    res.storeType.name = '售点形象';
  }
  // 处理售点类型的映射
  res.storeSaleType = {
    visible: true,
    name: '售点类型',
  };
  if (kaXTC(tenantCheckData)) { // 小天才租户
    res.storeSaleType.name = '售点类型';
  } else {
    res.storeSaleType.visible = false;
  }
  // 处理渠道类型的映射
  res.channelType = {
    visible: true,
    name: '渠道类型',
  };
  if (kaXTC(tenantCheckData)) { // 小天才租户
    res.channelType.name = '渠道类型';
  } else {
    res.channelType.visible = false;
  }
  // 处理销售品类的映射，目前是小天才独有的，仅做左侧栏数据控制，和门店筛选没有关系
  res.shopSalesType = {
    visible: true,
    name: '销售品类',
  };
  if (kaXTC(tenantCheckData)) { // 小天才租户
    res.shopSalesType.name = '销售品类';
  } else {
    res.shopSalesType.visible = false;
  }
  return res;
}

// 品牌商圈（大圈）筛选配置
function getBigCircleFilters(tenantCheckData, extraConfig) {
  const res:any = {
    visible: false, // 默认不显示
  };
  if (kaXTC(tenantCheckData) || extraConfig?.defaultConfig?.configSwitch?.capacityDisplayType === BrandBusinessAreaType.TemplateaA) { // 小天才租户 || 模型配置配了模板A
    res.visible = true;
  } else {
    res.visible = false;
  }
  // 处理门店状态参数的映射
  res.level = {
    visible: true,
    name: '商圈等级',
  };
  if (kaXTC(tenantCheckData)) { // 小天才租户
    res.level.visible = true;
  } else {
    res.level.visible = false;
  }
  return res;
}

// 管理片区筛选配置
function getManagementAreaFilters(tenantCheckData) {
  const res:any = {
    visible: false, // 默认不显示
    name: '管理片区显示',
  };
  if (kaXTC(tenantCheckData)) { // 小天才租户
    res.visible = true;
  }
  return res;
}

/* 顶部筛选栏配置 */
function getTopFilterConfig(tenantCheckData, typeDimension, extraConfig) {
  const config: any = {
    showFilterModelOut: false, // 是否把模型选择显示在外层，而不是藏在商圈显示筛选中。
    showMonthRangeFilter: false, // 是否需要使用月份范围筛选功能
    storeFilters: getStoreFilters(tenantCheckData, extraConfig), // 本品牌门店筛选项定制化
    bigCircleFilters: getBigCircleFilters(tenantCheckData, extraConfig), // 品牌商圈（大圈）筛选项定制化
    managementAreaFilters: getManagementAreaFilters(tenantCheckData), // 管理片区筛选项定制化
  };
  if (kaXTC(tenantCheckData) && typeDimension === 2) { // 小天才定制
    // 20251127迭代的时候小天才要求放到外面
    // showFilterModelOut = true;

    // 20251211迭代的时候小天才要求重新放到里面
    config.showFilterModelOut = false;

    config.showMonthRangeFilter = true;
  }
  return config;
}

/* 城市视角左侧栏配置 */
function getCityLeftContentConfig(tenantCheckData, extraConfig) {
  const config: any = {
    // sortRuleType=> distance: 会针对id=3的距离排序进行特殊处理, ruleless: 无规则模式，任何选项可选且不需要特殊交互
    // v20251225 sortRuleType => distance id改为13了
    sortRuleType: 'distance', // 筛选条件配置
    favorite: true, // 是否具备收藏功能
    rankFilter: true, // 是否具备排行筛选功能
    recommendTip: true, // 是否具备推荐提示
    export: !!extraConfig.permission?.some(item => item.enCode === 'youth:clusterExport'), // 是否具备导出功能
    hasMockDetail: extraConfig.userInfo.tenantInfo?.limitDetail, // 是否具备历史解锁日志查看功能
    pk: true, // 是否具备pk功能
    cityViewTab2: { // 城市模式下是否拥有管理片区tab项
      visible: false,
      // customTitle: extraConfig.manageArea,
      customTitle: '管理片区'
    },
    cityViewTab3: { // 城市模式下是否拥有品牌商圈（大圈）tab项
      visible: false,
      customTitle: extraConfig.brandBusinessArea,
    },
    cityViewTab4: {
      visible: true,
      customTitle: `${getShopCircleCustomName(tenantCheckData, extraConfig.openingAreaAlias)}信息`, // 是否自定义名称
    }, // 城市模式下是否拥有商圈-开店区域（小圈）tab项
  };
  if (kaXTC(tenantCheckData)) { // 小天才租户定制
    // 统一改为saas后台配置了，里面是有距离排序的
    // config.sortRuleType = 'ruleless'; // 没有距离排序，不需要特殊交互
    config.favorite = false;
    config.rankFilter = false;
    config.export = false;
    config.hasMockDetail = false;
    config.cityViewTab2.visible = true; // 开启管理片区
    config.pk = true;
    config.cityViewTab3.visible = true; // 开启大圈
    config.cityViewTab4.customTitle = 'Mall'; // 开启大圈
  } else if (extraConfig?.defaultConfig?.configSwitch?.capacityDisplayType === BrandBusinessAreaType.TemplateaA) {
    config.cityViewTab3.visible = true; // 开启大圈
  }
  return config;
}

/* 小圈（开店区域，基础版商圈，定制版Mall等）右侧详情卡片配置 */
function getSmallCircleRightCardConfig(tenantCheckData) {
  const config: any = {
    indicatorType: 'common', // 指标模块类型，默认是 common: 3个指标（日均客流量，xxkm 居住，工作，商圈等，也就是公司默认那一套）
  };
  if (kaXTC(tenantCheckData)) { // 小天才租户定制
    config.indicatorType = 'xtc'; // 定制的四个指标（月日均客流，常住人口，居住人口，活跃用户）
  }
  return config;
}

export enum ContentType {
  Default = 'saas',
  XTC = 'xtc',
  MXBC = 'mxbc'
}

// export const activeUserHeatMapXTC = 6;
export const activeUserHeatMapColors = [
  '#F3F7FF', // 热力值为0时分配的颜色
  '#FFFCEC',
  '#FFEFE2',
  '#FFE9C9',
  '#FFDFC3',
  '#FFD097',
  '#FFC073',
  '#FFB26F',
  '#FFB452',
  '#FF983F',
  '#FFB63F',
  '#FF861D',
  '#FF9100',
  '#FE7600',
  '#FE6000',
  '#F64500',
  '#FB4435',
  '#F21200',
  '#DC1100',
  '#BE0E00',
];
